import React from "react";
import Low from "Media/icons/Low.png";
import Moderate from "Media/icons/Moderate.png";
import Pause from "Media/icons/Pause.png";
import Urgent from "Media/icons/Urgent.png";

const CLOSED_BADGE_STYLE = {
  backgroundColor: "orange",
  borderRadius: "2px",
  textAlign: "center",
  width: "20px",
  height: "18px",
  color: "white",
  marginRight: "5px",
};

// Icon + text for a ticket severity; `pauseLabel` differs between some tables
const SeverityLabel = ({ severity, pauseLabel = "Pause" }) => {
  switch (severity?.toString()) {
    case "urgent":
      return (
        <>
          <img src={Urgent} alt="Urgent" /> Urgent
        </>
      );
    case "moderate":
      return (
        <>
          <img src={Moderate} alt="Moderate" /> Moderate
        </>
      );
    case "low":
      return (
        <>
          <img src={Low} alt="Low" /> Low
        </>
      );
    case "pause":
      return (
        <>
          <img src={Pause} alt="Pause" /> {pauseLabel}
        </>
      );
    case "closed":
      return (
        <>
          <span style={CLOSED_BADGE_STYLE}>C</span>
          Closed
        </>
      );
    default:
      return null;
  }
};

export default SeverityLabel;
